module.exports = __webpack_public_path__ + "static/media/esc.434c4892.svg";